import { cn } from "@ui/lib";
import Image from "next/image";

export function Logo({
	withLabel = true,
	size = "md",
	smOnMobile = false,
	className,
}: {
	className?: string;
	withLabel?: boolean;
	/** sm 给工作台侧栏：图标 26、字 16px，照 DeeVid（10/19，216 宽的侧栏里 30/18px 显大） */
	size?: "md" | "sm";
	/** md 以下图标缩到 26、md 起 30，和工作台手机页头一致（10/21 营销页顶栏用，只配 size=md） */
	smOnMobile?: boolean;
}) {
	const iconSize = size === "sm" ? 26 : 30;

	return (
		<span
			className={cn(
				"flex items-center font-semibold text-foreground leading-none",
				className,
			)}
		>
			<Image
				src="/images/logo.svg"
				alt="ImagesArt Logo"
				width={iconSize}
				height={iconSize}
				style={{
					height: "auto",
					width: "auto",
					// 分断点的上限写不进行内样式，交给下面的类
					...(!smOnMobile && { maxWidth: `${iconSize}px` }),
				}}
				className={cn(
					"object-contain",
					smOnMobile && "max-w-[26px] md:max-w-[30px]",
				)}
			/>
			{withLabel && (
				<span
					className={cn(
						"ml-2 hidden text-lg md:block text-[#1f11ed]",
						size === "sm" && "ml-1.5 text-base",
					)}
				>
					ImagesArt
				</span>
			)}
		</span>
	);
}
